export default function FloatingCta({ visible }) {
  return (
    <a
      className={`btn btn-primary floatcta${visible ? ' show' : ''}`}
      href="#pricing"
      tabIndex={visible ? 0 : -1}
      aria-hidden={visible ? undefined : true}
    >
      Join the Program
    </a>
  );
}
